<template>
  <div>
    <Logo></Logo>
    <!-- <Header /> -->
    <!-- 请求文字，三部分 -->
    <div class="box">
      <div class="title">{{ list.title }}</div>
      <div class="time">{{ list.created_time }}</div>
      <div class="tex" v-html="list.content">{{ list.content }}</div>
      <!-- <el-image v-if="list.cover !== undefined" :src="list.cover" fit="fill" lazy></el-image> -->
    </div>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
// import func from 'vue-editor-bridge'
export default {
  name: 'NewsDetail',
  data () {
    return {
      list: [],
    }
  },
  created () {
    this.detail();
  },
  methods: {
    async detail () {
      console.log('我是type', this.$route.query.type)
      if (this.$route.query.type == 1) {
        console.log(this.$route.query.id)
        const { data: data } = await api.getNewsOne(this.$route.query.id)
        if (data.code === 200) {
          this.list = data.data
          console.log('我是新闻详情', this.list)
        }
      } else {
        const { data: data } = await api.getIndOne(this.$route.query.id)
        if (data.code === 200) {
          this.list = data.data
          console.log('我是行业资讯', this.list)
        }
      }
    }
  },

  // mounted(){
  //   this.$nextTick(()=>{
  //     setTimeout(
  //       ()=>{
  //         var img_all = document.getElementsByClassName("tex")[0].getElementsByTagName("img");
  //         for(var i of img_all){
  //           i.style.width="100%";
  //         }
  //       }
  //     )
  //     }
  //   )
    
  //   // console.log(p_text);
  // },

  components: {
    // Header,
    Logo,
    Tabbar,
  },
}
</script>

<style scoped>
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.image {
  width: 43.875rem;
  height: 22.5rem;
  margin-left: 1.5rem;
}
.text {
  margin-top: 1rem;
  font-size: 1.75rem;
  color: #333333;
}
.title {
  color: #333333;
  font-size: 2.125rem;
  text-align: center;
  margin-top: 4rem;
}
.time {
  color: #666666;
  font-size: 1.375rem;
  font-weight: 300;
  height: 2.911875rem;
  margin-top: 2rem;
  display: flex;
  margin-right: 3rem;
  flex-direction: row-reverse;
}
.box {
  width: 43.875rem;
  /* width: 100%; */
  margin: auto;
  margin-top:10rem;
}
.tex{
  width: 100%;
  margin: 0 auto;
  font-size: 1.834rem;
  /* border: 1px solid black; */

}
.tex p img{
  width: 100% !important;
  border: 1px solid red;
  padding: 10px;
}


</style>
